//
import DispatchRequestDetailHeadersOriginal from './headers'

//
const default_fields = ({ g_branch_office_id, pos_sale_authorizations_length }) => [
    {
        title: 'venta original',
        fields: [
            {
                name: 'id',
                type: 'text-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Folio',
                    readonly: true,
                },
            },
            {
                name: 'g_seller_user_full_name',
                type: 'text-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Vendedor',
                    readonly: true,
                },
            },
            {
                name: 'pos_sale_pos_payment_types_str',
                type: 'text-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Tipo de pago',
                    readonly: true,
                },
            },
            {
                name: 'created_at',
                type: 'date-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Creado',
                    pickerProps: {
                        readonly: true,
                    },
                },
            },
            {
                name: 'g_state_name',
                type: 'text-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Estado',
                    readonly: true,
                },
            },
            {
                name: 'pos_detail_sales_original',
                type: 'table-field',
                flex: {
                    'pt-0': true,
                    xs12: true,
                },
                props: {
                    class: 'v-card elevation-2 mb-4',
                    headers: DispatchRequestDetailHeadersOriginal,
                    noActions: true,
                    noDataText: 'Sin productos.',
                    noFilter: true,
                    noExport: true,
                    noHelper: true,
                    noPagination: true,
                    noSearch: true,
                    label: 'Items',
                    showNativePagination: true,
                    toolbarTitle:
                        'Lista de productos incluidos en el ticket de venta',
                    toolbarColor: 'primary',
                    toolbarDark: true,
                    toolbarDense: true,
                    readonly: true,
                },
            },
            {
                name: '_',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {},
            },
            {
                name: 'discount_or_charge_percentage',
                type: 'percentage-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Descuento',
                    fieldProps: {
                        readonly: true,
                    },
                },
            },
            {
                name: 'invoice_total',
                type: 'currency-field',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {
                    label: 'Total',
                    fieldProps: {
                        readonly: true,
                    },
                },
            },
            {
                name: '_',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {},
            },
            {
                name: '_',
                flex: {
                    sm6: true,
                    lg3: true,
                },
                props: {},
            },
            {
                name: 'pos_sale_authorizations_reasons_text',
                type: 'textarea',
                flex: {
                    sm6: true,
                    lg6: true,
                },
                props: {
                    label: 'Razones de autorización',
                    readonly: true,
                },
            },
        ].filter((i, idx) => { console.log(pos_sale_authorizations_length); return pos_sale_authorizations_length > 0 ? true : idx < 8 }),
    },
]

//
export default ({ g_branch_office_id, pos_sale_authorizations_length }) =>
    default_fields({ g_branch_office_id, pos_sale_authorizations_length })
// : default_fields({ g_branch_office_id })[1]['fields']
